<template>
  <div class="slide-selector" ref="slide-selector">
    <div class="slide-list" >
      <div
        class="slide-thumb"
        :class="{selected: slideId ==  currentSlide}"
        v-for="(v, slideId) in slideData.slideCount"
        :key="slideId"
        v-on:click="selectSlide(slideId)"
        :style="{ 'background-image': 'url(' + slidePath+currentSlide+'.png)' }">
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions} from 'vuex'
import $config from '@/config'
import axios from 'axios'


export default {
  props: ['slideData'],
  data(){
    return{
      isReady: false,
      currentSlide: null,
      isUploading: false,
      uploadPercent:0,
    }
  },
  computed:{
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('slides', {
      getSlideDataInStore: 'find'
    }),
  },
  methods:{
    slidePath(slideId){
      return 'https://lcp.ams3.cdn.digitaloceanspaces.com/'+this.slideData.path+'/'+this.slideData.path+'-'+slideId+'.png';
    }
  }
}
</script>
